import lenoxData from "./lenoxData.js"
import commonFunctions from "./commonFunctions.js"
import lenoxFunctions from "./lenoxfunctions.js"


//var upr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
var scene7PreviewURL = lenoxData.baseUrl_1;
var personalizationScript = [
    'previewGemstone',
    'previewEngraving',
    'previewGemstoneEngraving',
    'previewSnowflake',
    'previewCrytalCrossMothersInfLove',
    'previewHeartNecklaceBracelet',
    'previewGemstone_2',
    'previewReednBarton'
];
var monSuffixTable = [
    // Suffix Code | SKU Suffix | Number of Array Elements to Use | Form Field Name
    // For repeating suffix code, the charElems must be ordered high to low.
    ["CONTEMPMON", "_mod", 3],
    ["TRADINTMON", "_trad", 3],
    ["INTPLATDIN", "-block", 1],
    ["MONPLATDIN", "-script", 1],
    ["INTGOLDDIN", "-block", 1],
    ["MONGOLDDIN", "-script", 1],
    ["INT1GLDBLK", "_book", 1],
    ["INT1GLDSCR", "_script", 1],
    ["OIPLATIN", "_mod", 1],
    ["OIPLATMON", "_trad", 3],
    ["TXT826495B", "_blue", 1],
    ["TXT826495P", "_pink", 1],
    ["TXT835020C", "_ark", 3, "TXT835020CMONOGRAM_00020_1"],
    ["TXT835020T", "_mod", 1, "TXT835020TINITIAL3_00010_1"],
    ["TXT835020T", "_trad", 3, "TXT835020TINITIAL3_00010_1"],
    ["TXT835266I", "_mod", 1],
    ["TXT835266M", "_trad", 3],
    ["TXT835955I", "_mod", 1],
    ["TXT835955M", "_trad", 3],
    ["TXT836656L", "_hor", 1],
    ["TXT836656P", "_ver", 1],
    ["TXT836657L", "_hor", 1],
    ["TXT836657P", "_ver", 1],
    ["TXT840121I", "_mod", 1],
    ["TXT840121M", "_trad", 3],
    ["TXT840119I", "_mod", 1],
    ["TXT840119M", "_trad", 3],
    ["TXT837872B", "-block", 1],
    ["TXT837872S", "-script", 1],
    ["TXT837607B", "-block", 1],
    ["TXT837607S", "-script", 1],
    ["TXT837608B", "-block", 1],
    ["TXT837608S", "-script", 1],
    ["TXT837859L", "_hor", 1],
    ["TXT837859P", "_ver", 1],
    ["TXT837860L", "_hor", 1],
    ["TXT837860P", "_ver", 1],
    ["TXT837875I", "_mod", 1],
    ["TXT837875M", "_trad", 3],
    ["TXT840531B", "_block", 1],
    ["TXT840531S", "_script", 1],
    ["TXT839993I", "_mod", 1],
    ["TXT839993M", "_trad", 3],
    ["TXT839994I", "_mod", 1],
    ["TXT839994M", "_trad", 3],
    ["TXT839995I", "_mod", 1],
    ["TXT839995M", "_trad", 3],
    ["TXT839996I", "_mod", 1],
    ["TXT839996M", "_trad", 3],
    ["TXT842485I", "_mod", 1],
    ["TXT842485M", "_trad", 3],
    ["TXT846935I", "_mod", 1],
    ["TXT846935M", "_trad", 3],
    ["TXT845335I", "_mod", 1],
    ["TXT845335M", "_trad", 3],
    ["TXT845524I", "_mod", 1],
    ["TXT845524M", "_trad", 3],
    ["TXT848224I", "_mod", 3],
    ["TXT848224M", "_trad", 3],
    ["TXT846581B", "_block", 1],
    ["TXT846581S", "_script", 1],
    ["TXT846583I", "_mod", 3],
    ["TXT846583M", "_trad", 3],
    ["TXT846589I", "_mod", 3],
    ["TXT846589M", "_trad", 3],
    ["TXT846582I", "_mod", 3],
    ["TXT846582M", "_trad", 3],
    ["TXT847886B", "_block", 0, "TXT847886BLINE1_00010_1", "TXT847886BLINE2_00020_1"],
    ["TXT847886S", "_script", 0, "TXT847886SLINE1_00010_1", "TXT847886SLINE2_00020_1"],
    ["TXT847878B", "_block", 0, "TXT847878BNAME_00010_1"],
    ["TXT847878S", "_script", 0, "TXT847878SNAME_00010_1"],
    ["TXT847879B", "_block", 0, "TXT847879BNAME_00010_1"],
    ["TXT847879S", "_script", 0, "TXT847879SNAME_00010_1"],
    ["FRAME2LNB", "_block", 0, "FRAME2LNBLINE1_00010_1", "FRAME2LNBLINE2_00020_1"],
    ["FRAME2LNS", "_script", 0, "FRAME2LNSLINE1_00010_1", "FRAME2LNSLINE2_00020_1"]
];

var previewGemstone = function (productID, styleName, valuesArray, width, height) {
    if (styleName) {
        var stones = valuesArray.filter(function (value) {
            return value.type === "option";
        }).map(function (stone) {
            return stone.value;
        });

        // Remove Number of Gems
        if (productID == "2647") {
            stones.shift();
        }

        // Remove Unselected elements
        for (var i = 0; i < stones.length; i++) {
            if (stones[i] == "***") {
                // Default to APR
                if (productID == "26361") {
                    stones[i] = "APR";
                } else {
                    stones[i] = commonFunctions.NO_STONE_LABEL;
                }
            }
            if (stones[i] == "" || stones[i] == undefined) {
                // Default to APR for these two products
                if (productID == "26361") {
                    stones[i] = "APR";
                } else if (productID == "2647") {
                    if (i >= 4) {
                        stones.splice(i, 1);
                        i--;
                    } else
                        stones[i] = commonFunctions.NO_STONE_LABEL;
                } else {
                    stones.splice(i, 1);
                    i--;
                }
            }
        }

        return scene7PreviewURL + lenoxFunctions.gemstonesURL(productID, width, height, stones);
    }
    return "";
};

var previewGemstone_2 = function (productID, styleName, valuesArray, width, height) {
    if (styleName) {
        var sku = commonFunctions.lookupSku(productID, lenoxData.lenoxProductTable_7);
        var stones = valuesArray.filter(function (value) {
            return value.type === "option";
        }).map(function (stone) {
            return stone.value;
        });
        // Remove Unselected elements
        if (sku != '092614' && sku != '087742' && sku != '098480' && sku != '091974') {
            //The following doesn't work for SKU '092614'...all others do???
            //var mothersSku = ['092614','087742','098480','784052','091974'];
            for (var i = 0; i < stones.length; i++) {
                if (stones[i] == "") {
                    stones.splice(i, 1);
                    i--;
                }
            }
        }
        return scene7PreviewURL + lenoxFunctions.gemstonesURL2(productID, width, height, stones);
    }
    return "";
};

var previewSnowflake = function (productID, styleName, valuesArray, width, height) {
    if (styleName) {
        var stones = valuesArray.filter(function (value) {
            return value.type === "option";
        }).map(function (stone) {
            return stone.value;
        });

        var textStrings = valuesArray.filter(function (value) {
            return value.type = "string";
        }).map(function (text) {
            return encodeURIComponent(text.value);
        });

        // Encode text string to allow characters to pass on URL.
        for (var i = 0; i < textStrings.length; i++) {
            if (textStrings[i] == undefined) {
                textStrings[i] = "";
            } else {
                textStrings[i] = encodeURIComponent(textStrings[i]);
            }
        }
        return scene7PreviewURL + lenoxFunctions.snowFlakeURL(productID, width, height, stones, textStrings);
    }
};

var previewCrytalCrossMothersInfLove = function (productID, styleName, valuesArray) {
    if (styleName) {
        var sku = commonFunctions.lookupSku(productID, lenoxData.lenoxProductTable_5);
        var url = "";
        var numGems = 0;
        var gemTable;
        var i;
        var stones = valuesArray.filter(function (value) {
            return value.type === "option";
        }).map(function (stone) {
            return stone.value;
        });

        // Get the number of gems
        if (productID == "9699") {
            numGems = 11;
        } else if (productID == "12955") {
            numGems = 10;
        } else if (productID == "15171") {
            var month = stones[1];
            numGems = 0;
            for (i = 0; i < lenoxData.monthTable2.length; i++) {
                if (month == lenoxData.monthTable2[i][1]) {
                    numGems = i + 1;
                    break;
                }
            }
            if (numGems == 0) {
                alert("Please select a Birthstone Month");
            }
        } else if (productID == "6018") {
            numGems = document.personalizeForm.step.options[document.personalizeForm.step.selectedIndex].text;
            stones.shift();
        } else if (productID == "15681") {
            numGems = stones[0];
            if (isNaN(numGems) || numGems.length == 0) {
                numGems = 0;
            }
        } else {
            numGems = stones.length;
        }

        if (productID === "26641" || productID === "21825") {
            for (i = 0; i < stones.length; i++) {
                if (stones[i] == "***" || stones[i] == "" || stones[i] == undefined) {
                    // Default to APR
                    stones[i] = "APR";
                }
            }
        }

        // Remove empty array elements
        if (productID != "15171") {
            var counter = numGems;
            for (i = 0; i < counter; i++) {
                if (stones[i] == "") {
                    stones.splice(i, 1);
                    i--;
                    counter--;
                }
            }
            numGems = counter;
        }

        // Get the correct url s7 query
        for (i = 0; i < lenoxData.lenoxVignetteTable_5.length; i++) {
            if (sku == lenoxData.lenoxVignetteTable_5[i][commonFunctions.productDisplayNameInd]) {
                url = lenoxData.lenoxVignetteTable_5[i][1][numGems - 1];
                break;
            }
        }

        // build the s7 url call, replacing the 0,0,0 with the gemColor
        gemTable = commonFunctions.getGemTable(productID);
        for (var j = 0; j < numGems; j++) {
            var gemName = stones[j];
            var gemColor = commonFunctions.getItemRGBColor(gemName, gemTable);
            if (gemName == commonFunctions.NO_STONE_LABEL) {
                url = url.replace("0,0,0", "r,g,b");
            } else {
                if (gemColor.indexOf(",") == -1) {
                    url = url.replace("facet&show&color=0,0,0", gemColor + "&show");
                } else
                    url = url.replace("0,0,0", gemColor);
            }
        }

        if (url != undefined) {
            return scene7PreviewURL + url.replace(/r,g,b/g, "0,0,0");
        }

        return "";
    }
    return "";
};

var previewEngraving = function (productID, styleName, valuesArray, width, height) {
    var isMonogram = false,
        textSelectIndex = 0,
        productCode = productID;	// Product Code will contain the Product ID + any suffix

    // Monogram Suffix Table
    var index = {
        suffixCode: 0,
        skuSuffix: 1,
        charElems: 2,
        formFieldName: 3,
        formFieldName2: 4
    };

    var suffix;

    var lookupSuffix = function (suffixCode) {//todo: jquery dom refs - rework
        for (var i = 0; i < monSuffixTable.length; i++) {
            if (suffixCode == monSuffixTable[i][index.suffixCode]) {
                if (monSuffixTable[i][index.formFieldName] !== undefined) {
                    // Need to test the length of data entered to choose the correct suffix.
                    var text = jQuery('[name=' + monSuffixTable[i][index.formFieldName] + ']').val();
                    var textLen = jQuery.trim(text).length;
                    if (monSuffixTable[i][index.charElems] == 0) {
                        return monSuffixTable[i];
                    } else if (textLen <= monSuffixTable[i][index.charElems]) {
                        return monSuffixTable[i];
                    }
                } else {
                    return monSuffixTable[i];
                }
            }
        }
        return null;
    };

    // Append Suffix to SKU
    //The following skus are products which use the suffix feature but are NOT monogram or initial only engravings (akersha 2.7.2014)
    var monogramExceptions = "836656,836657,837859,837860,846581,27637,27643,27645,27647,27649";

    suffix = lookupSuffix(styleName);
    if (suffix != null) {
        productCode = productID + suffix[index.skuSuffix];
        isMonogram = monogramExceptions.indexOf(productID) < 0;
    }

    // build out the textstrings based on the customer's input
    var textStrings = valuesArray.filter(function (value) {
        return value.type = "string";
    }).map(function (text) {
        return encodeURIComponent(text.value);
    });

    // For monogram place settings with block and script font options
    if (isMonogram) {
        textStrings[0] = textStrings[textSelectIndex];
        textStrings.splice(1, textStrings.length - 1);

        // Break element 1 into 3 single character elements
        if (suffix[index.charElems] > 1) {
            // If length is 2, then add a blank to the middle to keep the two characters the same size.
            var addBlankMiddle = (textStrings[0].length == 2 && suffix[index.charElems] == 3);
            var bookendBlank = (textStrings[0].length == 1 && suffix[index.charElems] == 3);
            // Force string length to number of required array elements (charElems), then create the array
            var val = textStrings[0] + new Array(suffix[index.charElems] + 1).join(' '); // This appends n blanks
            textStrings = val.split("", suffix[index.charElems]);
            if (addBlankMiddle) {
                textStrings.splice(1, 0, "");
            }
            // If only single initial is provided, add beginning and trailing blank.
            if (bookendBlank) {
                textStrings.splice(0, 0, "");
                textStrings.pop();
            }
        }
    } else {
        var frames = [27637, 27639, 27641, 27643, 27645, 27647, 27649];
        if (frames.indexOf(productID) >= 0) {
            textStrings = [];
            if (suffix[index.formFieldName] !== undefined) {//todo: jquery dom refs - rework
                textStrings.push(encodeURIComponent(jQuery.trim(jQuery('[name=' + suffix[index.formFieldName] + ']').val())));
                if (suffix[index.formFieldName2] !== undefined) {
                    textStrings.push(encodeURIComponent(jQuery.trim(jQuery('[name=' + suffix[index.formFieldName2] + ']').val())));
                }
            }
        }
    }

    // This product only has one initial, but must be replicated in all 4 text string positions
    //try {
    if (productID == 14315) {
        for (var i = 1; i < 4; i++) {
            textStrings[i] = textStrings[0];
        }
    }
    // Move year to first element
    if (productID == 26671) {
        var year = textStrings.pop();
        textStrings.unshift(year);
    }

    var url = '';
    try {
        var url_surfix = lenoxFunctions.engravingsURL(productCode, width, height, textStrings);
        if(url_surfix != '') {
            url = scene7PreviewURL + url_surfix;
        }
    } catch (e) {
        console.error(e);
        url = "";
    }
    return url;
};

var previewGemstoneEngraving = function (productID, styleName, valuesArray, width, height) {
    if (styleName) {
        var stones = valuesArray.filter(function (value) {
            return value.type === "option";
        });
        var textStrings = valuesArray.filter(function (value) {
            return value.type === "string";
        });

        // logic for item 9276 - we need to know boy or girl before we can start
        if (productID === '9276') {
            productID = stones[0].value === 'PINK' ? productID + '_girl' : productID + '_boy';
        }

        var texts = textStrings.map(function (text) {
            return encodeURIComponent(text.value);
        });

        return scene7PreviewURL + lenoxFunctions.gemstonestextURL(productID, width, height, stones.map(function (stone) {
            return stone.value;
        }), texts);
    }

    return "";
};

var previewHeartNecklaceBracelet = function (productID, styleName, valuesArray) {
    if (styleName) {
        var stones = valuesArray.filter(function (value) {
            return value.type === "option";
        }).map(function (value) {
            return value.value;
        });
        var textStrings = valuesArray.filter(function (value) {
            return value.type === "string";
        }).map(function (text) {
            return text.value;
        });

        // Encode text string to allow characters to pass on URL.
        if (textStrings[0] == "") {
            return false;
        }

        textString = textStrings[0];
        return scene7PreviewURL + custom_monogrammedHeartCountURL(productID, textString, lenoxData.lenoxProductTable_6, lenoxData.lenoxVignetteTable_6, stones);
    }
    return "";
};

var custom_monogrammedHeartCountURL = function (selectedProductId, textString, pTable, vTable, stones) {
    var url = "";
    var selectedProductSku = commonFunctions.lookupSku(selectedProductId, pTable);
    var numHearts = textString.length;
    for (var i = 0; i < vTable.length; i++) {
        if (selectedProductSku == vTable[i][commonFunctions.productDisplayNameInd]) {
            url = vTable[i][1][numHearts - 1];
            break;
        }
    }

    if (stones != null) {
        var selectedMonth = stones[0];
        if (url.indexOf("obj=GEMS") != -1) {
            if (selectedMonth == commonFunctions.NO_STONE_LABEL)
                url = url.replace(/&obj=GEMS\/\$month&show/, "");
            else
                url = url.replace("$month", lenoxData.monthTable[selectedMonth]);
        } else {
            var gemTable = commonFunctions.getGemTable(selectedProductId);
            var gemColor = commonFunctions.getItemRGBColor(selectedMonth, gemTable);
            url = url.replace("0,0,0", gemColor);
        }
    }

    for (i = 0; i < numHearts; i++) {
        monogram = encodeURIComponent(textString.substring(i, i + 1));
        url = url.replace(/\$text=\w*&/, "$texxxt=" + monogram + "&");
    }

    return url.replace(/texxxt=/g, "text=");
};

var previewReednBarton = function (productID, styleName, values) {
    var sku = productID;
    if (lenoxData.scene7.styles[sku]) {
        var font_name_array = [];
        var textArray = [];
        for (var i = 0, lth = values.length; i < lth; i++) {
            var value = values[i];
            if (value.type === "font") {
                font_name_array.push(value.value);
            } else if (value.type === "string") {
                textArray.push(value.value);
            }
        }
        if (styleName !== "NOPERSONAL") {
            return lenoxData.scene7.getUrl(sku, styleName, textArray, font_name_array);
        }
    }
    return "";
};

export default {
    scene7PreviewURL: scene7PreviewURL,
    personalizationScript: personalizationScript,
    monSuffixTable: monSuffixTable,
    previewGemstone: previewGemstone,
    previewGemstone_2: previewGemstone_2,
    previewSnowflake: previewSnowflake,
    previewCrytalCrossMothersInfLove: previewCrytalCrossMothersInfLove,
    previewEngraving: previewEngraving,
    previewGemstoneEngraving: previewGemstoneEngraving,
    previewHeartNecklaceBracelet: previewHeartNecklaceBracelet,
    custom_monogrammedHeartCountURL: custom_monogrammedHeartCountURL,
    previewReednBarton: previewReednBarton
};



// WEBPACK FOOTER //
// ../assets/js/personalize/preview/index.js